import { createContext, useContext, useEffect } from "react";

// Lets each logged-out page (Login/SignUp/Reset/Change password) register its own
// heading text with LoggedOutWrapper, which renders it inside the mobile-only header
// band. The band is rendered by the wrapper, outside of {children}, so a page can't
// place content into it directly via JSX — this context is the bridge. Default is a
// no-op setter so the hook is harmless if ever used outside the provider.
export const LoggedOutHeaderContext = createContext(() => {});

export const useLoggedOutHeading = (text) => {
  const setHeading = useContext(LoggedOutHeaderContext);
  useEffect(() => {
    setHeading(text);
  }, [text, setHeading]);
};
